import { Modal, Form, Input, message } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { t } from 'ttag';

import Label from 'common/components/Label';

import { useCreateStaffMutation } from './queries';

const CreateModal = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const createMutation = useCreateStaffMutation();

  const handleSubmit = values => {
    createMutation.mutate(values, {
      onSuccess: () => {
        message.success(t`Staff member added successfully`);
        form.resetFields();
        onClose(true);
      },
      onError: () => {
        message.error(t`Failed to add staff member. Please try again.`);
      },
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose(false);
  };

  return (
    <Modal
      title={t`Add Staff Member`}
      open={visible}
      onCancel={handleCancel}
      destroyOnClose
      okText={t`Add Staff Member`}
      okButtonProps={{
        loading: createMutation.isLoading,
        htmlType: 'submit',
        form: 'create-staff-form',
      }}
      cancelText={t`Cancel`}
      cancelButtonProps={{ disabled: createMutation.isLoading }}
    >
      <Form
        form={form}
        id="create-staff-form"
        layout="vertical"
        requiredMark={false}
        onFinish={handleSubmit}
        disabled={createMutation.isLoading}
      >
        <Form.Item
          name="email"
          label={<Label>{t`Email Address`}</Label>}
          rules={[
            { required: true, message: t`Email is required.` },
            { type: 'email', message: t`Please enter a valid email address.` },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

CreateModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CreateModal;
